<template>
  <div class="footerWrap">
    <div class="footerNav">
      <div>
        <div style="padding: 5px 0;"><a href="javascript:;" style="color: #333;">联系方式</a></div>
        <div style="padding: 5px 0;"><a href="javascript:;" style="color: #333;font-size: 12px;">联系电话：0755-26401941
          18666821228</a></div>
        <div style="padding: 5px 0;"><a href="javascript:;" style="color: #333;font-size: 12px;">企业邮箱：
          22031203@163.com</a></div>
        <div style="padding: 5px 0;"><a href="javascript:;" style="color: #333;font-size: 12px;">公司地址：
          深圳市宝安区新安街道大浪社区28区新安三路一巷24号汇聚宝安湾智创园B栋506</a></div>
      </div>
      <div class="ma_wrap">
        <div >
          <div style="text-align: center;"><img src="./imgs/erweima.jpg" style="width: 100px;"></div>
          <div class="bottom_tips">扫一扫 关注公众号</div>
        </div>
        <div>
          <div style="text-align: center;"><img src="./imgs/xiaocx.jpg" style="height:120px"></div>
<!--          <div class="bottom_tips">鑫安智能物联云</div>-->
        </div>
      </div>
    </div>
<!--    <img src="./imgs/policeLogo.png" style="width: 15px;margin-right: 5px;">-->
    <div class="police" @click="toMiit()">粤ICP备2022003579号</div>
  </div>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        isshow: "",
      }
    },
    created() {

    },
    methods: {
      toMiit(){
        window.open("https://beian.miit.gov.cn/#/Integrated/index")
      }
    },
    watch: {}
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixin.styl"
  .footerWrap
    width 100%
    border-top 1px solid #ccc
  .footerNav
    width 1200px
    color #333
    margin 0 auto
    padding 20px 0
    display flex
    justify-content space-between
    .ma_wrap
      width 460px
      display flex
      justify-content space-between
    .bottom_tips
      margin-top 5px
      font-size 12px
      text-align center
  .police
    cursor pointer
    border-top: 1px solid #ccc;
    text-align: center;
    padding: 5px 0;
    color: gray;
    font-size: 14px;
    min-width: 1200px;
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue